<template>
  <div id="csPage" class="container-fluid min-vh-100 pl-2 pr-2 pb-2">
    <b-row class="min-vh-100">
      <!-- Sidebar Chat untuk HP dan Desktop -->
      <b-col sm="12" md="4" class="min-vh-100 p-0">
        <floating-chat ref="cs"
          :isFloating="false"
          @is-connect="isConnect"
          @chat-list="setMessage"
          @push-chat-list="pushChatList"
          @set-category="setCategory"
          @show-loader="showLoader"
        />
      </b-col>

      <!-- Bagian Chat Utama -->
      <b-col sm="12" md="8" class="vh-100 overflow-hidden">
        <!-- Loader -->
        <div v-if="isLoader" class="d-flex align-items-center justify-content-center h-100">
          <div class="dot-falling"></div>
        </div>

        <!-- Chat List -->
        <div v-else-if="currentCategory" class="vh-100 d-flex flex-column">
          <ChatList
            :list="messages"
            ref="list-message"
            class="h-100 overflow-auto pt-3"
          /><br>
          <chat-input
            v-if="messages.length === 0 || (messages.length > 0 && messages[0].status === 1)"
            ref="chatInput"
            @capture-file="captureFile"
            @send-message="sendMessage"
          />
        </div>

        <!-- Placeholder Jika Tidak Ada Chat -->
        <div v-else class="p-5 text-center mt-3">
          <img :src="`${publicPath}/img/rcp/empty-message.png`" class="mb-5 max-w-100" />
          <div class="text-center fw-400 fz-14 caption">
            {{ $t("You haven't asked something, create your question and this live chat is ready to help answer your question quickly and accurately.") }}
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- Loader Komponen -->
    <LoaderComponent v-if="isLoading" />
  </div>
</template>

<script>
import FloatingChat from "@/components/Chat/Chat.vue";
import ChatList from "@/components/Chat/ChatList";
import ChatInput from "@/components/Chat/ChatInput";
import LoaderComponent from "@/components/LoaderComponent";

export default {
  data() {
    return {
      publicPath: process.env.BASE_URL !== "/" ? process.env.BASE_URL : "",
      currentCategory: "",
      messages: [],
      isLoader: false,
      isLoading: false,
    };
  },
  components: {
    FloatingChat,
    ChatList,
    ChatInput,
    LoaderComponent,
  },
  methods: {
    isConnect(isConnect) {
      this.isLoading = !isConnect;
    },
    setMessage(data) {
      console.log("Set message list:", data);
      this.messages = data;
      if (this.$refs["list-message"]) {
        this.$refs["list-message"].messages = data;
      }
    },
    setCategory(category) {
      this.currentCategory = category;
    },
    captureFile(event) {
      this.$refs["cs"].captureFile(event);
    },
    sendMessage(message) {
      this.$refs["cs"].sendMessage(message);
    },
    showLoader(param) {
      this.isLoader = param;
    },
    pushChatList(param) {
      console.log("Push chat list:", param);
      if (param) {
        this.messages.push({
          "user_type":param.user_type,
          "message":param.message,
          "info":param.info
        });
      }
    },
  },
};
</script>
